export default __webpack_public_path__ + "static/media/ReportZoom.bbc317c3.svg";